<template>
  <div>
    <v-navigation-drawer v-model="drawer" app>
      <v-list>
        <v-list-tile class="py-0">
          <router-link
            style="text-decoration: none; color:#0c3063;"
            to="/"
            class="d-flex align-center"
          >
            <img src="@/assets/max_logo.png" alt="Vizmo" height="42" />
            <span class="headline mt-1">&nbsp;Admin</span>
          </router-link>
        </v-list-tile>
      </v-list>
      <v-divider />

      <v-list>
        <template v-for="item in drawerItems">
          <v-list-group
            v-if="item.children"
            :key="item.key"
            :value="/^\/admin\/settings\/.+/g.test($route.path)"
            no-action
          >
            <v-list-tile slot="activator">
              <v-list-tile-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-for="subItem in item.children" :key="subItem.to" :to="subItem.to">
              <v-list-tile-action>
                <v-icon>{{ subItem.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
          <v-list-tile v-else :key="item.to" :to="item.to">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar color="primary" height="64" app>
      <v-toolbar-side-icon dark @click.stop="drawer = !drawer" />
      <v-toolbar-title>
        <span class="headline white--text">{{ $store.state.toolbarTitle }}</span>
      </v-toolbar-title>
      <v-spacer />
      <v-menu offset-y>
        <avatar
          slot="activator"
          :src="$store.state.profile['photoUrl']"
          :text="$store.state.profile['name']"
          color="accent"
        />
        <v-card class="max-shadow">
          <v-card-title>
            <span class="profile-name subheading">{{ $store.state.profile.name }}</span>
          </v-card-title>
          <v-divider />
          <v-list>
            <v-list-tile to="/admin/profile">
              <v-list-tile-content>
                <v-list-tile-title>Profile</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="logout">
              <v-list-tile-content>
                <v-list-tile-title>Log Out</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card>
      </v-menu>
    </v-toolbar>
    <v-content>
      <router-view />
    </v-content>
  </div>
</template>

<script>
import { auth } from '@/firebase';

import avatar from '@/components/common/Avatar';

export default {
  components: {
    avatar
  },
  data() {
    return {
      drawer: false,
      drawerItems: [
        {
          to: '/admin/dashboard',
          icon: 'dashboard',
          title: 'Dashboard',
          children: false
        },
        {
          to: '/admin/employees',
          icon: 'people',
          title: 'Employees',
          children: false
        },
        {
          to: '/admin/vms',
          icon: 'mdi-account-card-details',
          title: 'Visitor Management',
          children: [
            {
              to: '/admin/vms/visitor-log',
              icon: 'mdi-account-tie',
              title: 'Visitor Log'
            },
            {
              to: '/admin/vms/invites',
              icon: 'insert_invitation',
              title: 'Invites'
            }
          ]
        },
        {
          to: '/admin/facilities',
          icon: 'event_note',
          title: 'Meeting Rooms',
          children: false
        },
        {
          to: '/admin/amenities',
          icon: 'mdi-dumbbell',
          title: 'Amenities',
          children: false
        },
        {
          to: '/admin/help-desk',
          icon: 'headset_mic',
          title: 'Help Desk',
          children: false
        },
        {
          to: '/admin/analytics',
          icon: 'bar_chart',
          title: 'Analytics',
          children: [
            {
              to: '/admin/analytics/helpDesk',
              icon: 'headset_mic',
              title: 'Help Desk'
            },
            {
              to: '/admin/analytics/facilities',
              icon: 'mdi-dumbbell',
              title: 'Meeting Rooms'
            }
          ]
        },
        {
          to: '/admin/invoices',
          icon: 'receipt',
          title: 'Invoices',
          children: false
        },
        {
          to: '/admin/settings',
          icon: 'settings',
          title: 'Settings',
          children: [
            {
              to: '/admin/settings/company',
              icon: 'business',
              title: 'Company'
            },
            {
              to: '/admin/settings/help-desk',
              icon: 'headset_mic',
              title: 'Help Desk'
            }
          ]
        }
      ]
    };
  },
  created() {
    this.drawer = this.$vuetify.breakpoint.lgAndUp;
    const VMS = {
      lid: '-L9iX4TPTVv6CQWfgCkE'
    };
    this.$store.commit('setVMS', { VMS });

    this.$store.dispatch('getVisitorLog');
    this.$store.dispatch('getExpectedVisitors');
  },
  methods: {
    logout() {
      auth.signOut();
      //* we need to set profile null so that login-guard allows us to show login page immediately
      this.$store.commit('setProfile', { profile: null });
      this.$router.push('/login');
    }
  }
};
</script>

<style scoped>
.vlist-active-tile {
  color: #04325d !important;
  background-color: rgb(4, 50, 93, 0.2) !important;
}

.profile-name {
  font-weight: 500;
}
</style>
